import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Helpers } from '../../../helpers';
import { User } from "../../../auth/_models/index";
import { UserService } from "../../../auth/_services/user.service";
import { Tester } from '../../../auth/_models/tester';
declare let mLayout: any;
@Component({
    selector: "app-header-nav",
    templateUrl: "./header-nav.component.html",
    encapsulation: ViewEncapsulation.None,
    providers: [UserService]
})
export class HeaderNavComponent implements OnInit, AfterViewInit {


    user: User;
    constructor(private service: UserService) {

    }
    ngOnInit() {
        this.user = this.service.getSessionUser();
    }
    ngAfterViewInit() {

        mLayout.initHeader();

    }
}


// WEBPACK FOOTER //
// ./src/app/theme/layouts/header-nav/header-nav.component.ts